module.exports = __webpack_public_path__ + "img/组 6@2x.33eb8293.png";